import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Layout, Box, BarChart, FileText, Settings, Plus } from 'lucide-react';
import { motion } from 'framer-motion';
import AssetOverview from './components/overview/AssetOverview';
import AssetInventory from './components/inventory/AssetInventory';
import AssetAnalytics from './components/analytics/AssetAnalytics';
import AssetReports from './components/reports/AssetReports';
import AssetSettings from './components/settings/AssetSettings';

const AssetsDashboard = () => {
  const [activeTab, setActiveTab] = useState('overview');

  const tabs = [
    { id: 'overview', label: 'Overview', icon: Layout },
    { id: 'inventory', label: 'Asset Inventory', icon: Box },
    { id: 'analytics', label: 'Analytics', icon: BarChart },
    { id: 'reports', label: 'Reports', icon: FileText },
    { id: 'settings', label: 'Settings', icon: Settings }
  ];

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="bg-[#43302b] rounded-xl p-6 text-white">
        <div className="flex justify-between items-start">
          <div>
            <h1 className="text-2xl font-semibold">Asset Management</h1>
            <p className="text-brown-100 mt-1">Track and manage company assets, equipment, and resources</p>
          </div>
          <Link
            to="/assets/new-asset"
            className="px-4 py-2 bg-white text-[#43302b] rounded-lg hover:bg-brown-50 transition-colors flex items-center gap-2 font-medium"
          >
            <Plus className="w-5 h-5" />
            Add Asset
          </Link>
        </div>

        {/* Centered Tabs */}
        <div className="mt-6 flex justify-center">
          <div className="inline-flex space-x-1 bg-white/10 rounded-lg p-1 backdrop-blur-sm">
            {tabs.map((tab) => {
              const Icon = tab.icon;
              return (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                    activeTab === tab.id
                      ? 'bg-white text-[#43302b]'
                      : 'text-white/90 hover:bg-white/10'
                  }`}
                >
                  <Icon className="w-4 h-4" />
                  {tab.label}
                </button>
              );
            })}
          </div>
        </div>
      </div>

      {/* Tab Content */}
      <div className="space-y-6">
        {activeTab === 'overview' && <AssetOverview />}
        {activeTab === 'inventory' && <AssetInventory />}
        {activeTab === 'analytics' && <AssetAnalytics />}
        {activeTab === 'reports' && <AssetReports />}
        {activeTab === 'settings' && <AssetSettings />}
      </div>
    </div>
  );
};

export default AssetsDashboard;